// sitemap-generator.js

// Recursively fetch all products using Shopify's JSON endpoint.
async function fetchAllProducts(page = 1, products = []) {
  try {
    const response = await fetch(`/products.json?limit=250&page=${page}`);
    if (!response.ok) {
      console.error('Error fetching products:', response.status);
      return products;
    }
    const data = await response.json();
    if (data.products && data.products.length > 0) {
      products = products.concat(data.products);
      // Recursively fetch the next page.
      return fetchAllProducts(page + 1, products);
    }
    return products;
  } catch (error) {
    console.error('Fetch error:', error);
    return products;
  }
}

// Generate the XML sitemap for product images and trigger download.
async function generateSitemap() {
  const products = await fetchAllProducts();
  let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
  xml += '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" ';
  xml += 'xmlns:image="http://www.google.com/schemas/sitemap-image/1.1">\n';

  // Base URL for constructing product page URLs.
  const baseUrl = window.location.origin;

  products.forEach(product => {
    // Only include products with images.
    if (product.images && product.images.length > 0) {
      xml += '  <url>\n';
      xml += `    <loc>${baseUrl}/products/${product.handle}</loc>\n`;
      product.images.forEach(image => {
        xml += '    <image:image>\n';
        xml += `      <image:loc>${image.src}</image:loc>\n`;
        xml += '    </image:image>\n';
      });
      xml += '  </url>\n';
    }
  });
  xml += '</urlset>';

  // Create a Blob for the XML and trigger a download.
  const blob = new Blob([xml], { type: 'text/xml' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'product-images-sitemap.xml';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Attach the event to the button (if using a button)
document.addEventListener('DOMContentLoaded', function () {
  const button = document.getElementById('generate-sitemap');
  if (button) {
    button.addEventListener('click', generateSitemap);
  } else {
    // If no button exists, you can choose to run the function automatically.
    // Uncomment the line below to auto-generate on page load.
    // generateSitemap();
  }
});